module.exports = __webpack_public_path__ + "asset/img/shop-switch.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/shop-switch.svg
// module id = 888
// module chunks = 2 3